import { CdkPortal } from "@angular/cdk/portal";
import { Directive, TemplateRef, ViewContainerRef, inject } from "@angular/core";

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[option-template]ng-template" })
export class AutcompleteOptionTemplateDirective extends CdkPortal {
   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[label-template]ng-template" })
export class AutcompleteLabelTemplateDirective extends CdkPortal {
   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[header-template]ng-template" })
export class AutocompleteHeaderTemplateDirective extends CdkPortal {
   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[footer-template]" })
export class AutocompleteFooterTemplateDirective extends CdkPortal {
   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}
